<template>
  <div>
    <van-nav-bar @click-left="$router.go(-1)" left-arrow />

    <div class="flex flex-center paysuc">
      <div class="wrap">
        <van-icon name="certificate" style="font-size: 7rem;" color="#1989fa" />
        <div>支付成功</div>
        <van-button @click="$router.push('/mine')" style="margin-right: 1rem;"
          >返回首页</van-button
        >
        <van-button type="info" @click="$router.push('/orderList')"
          >查看订单</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.paysuc {
  height: calc(100vh - 46px);
}
.wrap {
  text-align: center;
  > div {
    margin: 2rem 0;
  }
}
</style>
